/**
 * C4Profile — Simon Brown's C4 model (Context, Container, Component, Deployment).
 * See plans/software-design/domain.md § 10.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type C4NodeType = 'c4_person' | 'c4_system' | 'c4_container' | 'c4_component' | 'c4_deployment_node';
export type C4EdgeType = 'c4_uses' | 'c4_delivers';

export const C4Profile: DomainDataProfile<C4NodeType, C4EdgeType> = {
  domainId: 'c4',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['c4_person', 'c4_system', 'c4_container', 'c4_component', 'c4_deployment_node'],
  edgeTypes: ['c4_uses', 'c4_delivers'],
  vocabulary: {
    recordSingular: 'Element',
    recordPlural: 'Elements',
    repositoryLabel: 'System',
    hierarchyLabel: 'Contains',
    importAction: 'Import C4',
    keyColumnHint: 'Element',
    commitLabel: 'Push C4',
    pullLabel: 'Refresh C4',
    diagramLabel: 'C4 diagram',
  },
  fieldAliases: {
    name: ['elementName'],
  },
  requiredProps: ['name'],
  recommendedProps: ['description', 'technology'],
  primaryShapeType: 'c4_container',
  propsToAttrsMapping: {
    name: 'name',
    description: 'description',
    technology: 'technology',
    level: 'level', // context | container | component | deployment
  },
  relationshipPackId: 'software-design-relationships',
};
